import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule, MatInputModule } from '@angular/material';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from '../../authentication/auth-guard.service';
import { DemoVideosComponent } from './demo-videos.component';

const routes: Routes = [
    { path: '', redirectTo: 'demo-videos', pathMatch: 'full', canActivate: [AuthGuardService] },
    { path: 'demo-videos', component: DemoVideosComponent, canActivate: [AuthGuardService] }
]

@NgModule({
    declarations: [
        DemoVideosComponent
    ],
    imports: [
        RouterModule.forChild(routes),
        BrowserModule,
        MatFormFieldModule,
        FormsModule,
        MatInputModule
    ],
    exports: [],
    providers: [

    ]
})

export class DemoVideosModule {

}
